export const comments_5089932 = {"data":{"data":[],"links":{}}}